var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('font-awesome-icon',{attrs:{"role":"icon","icon":[_vm.iconStyle, _vm.icon]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }